<template>
  <div>
    <keep-alive>
      <Drafts
        :load="loadSendersAndRecievers"
        :type="type"
        :options="options"
        :form-validation="validate[type]"
        @handle-place-dialog="handleCityDialog"
        @switch="switchOption"
      />
    </keep-alive>

    <div class="pb-05">
      <v-card class="pt-4" elevation="0" rounded="0">
        <div class="row mx-4 rounded-sides border-grey">
          <div
            v-for="option of options"
            :key="option.id"
            class="pa-0 col id-option"
          >
            <div
              @click="switchOption(option)"
              class="pa-3 border cursor-pointer"
              :class="option.active && 'active-option'"
              elevation="0"
            >
              <v-icon
                v-if="option.active"
                size="20"
                class="ml-2 logistic--text force-color"
                >mdi-check-circle</v-icon
              >
              <v-icon v-else size="20" class="ml-2 grey--text">mdi-circle-outline</v-icon>
              <small class="bold" v-text="option.name"></small>
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <div class="pb-3 pt-2 pt-md-3 px-0 row mx-0">
      <div
        v-for="(input, index) of inputs"
        :key="type + index"
        class="col-12 px-4 pb-0"
      >
        <v-text-field
          :rules="input.rule && input.rule"
          v-model="loadSendersAndRecievers[input.model]"
          color="var(--logistic)"
          :label="input.label"
          :type="input.type"
          height="50"
          clearable
          outlined
          :required="true"
          dense
        ></v-text-field>
      </div>

      <div class="col-12 px-4 pt-4 pt-md-3 pb-0">
        <v-text-field
          :key="selectedCity"
          :rules="[$utils.validators.required]"
          append-icon="mdi-chevron-left"
          @focus="$emit('toggle-city-dialog', placeIndex)"
          :label="`انتخاب شهر ${place}`"
          color="var(--logistic)"
          :value="
            loadSendersAndRecievers.city &&
            loadSendersAndRecievers.ostan + ' - ' + loadSendersAndRecievers.city
          "
          height="50"
          type="text"
          clearable
          outlined
          required
          dense
        ></v-text-field>
      </div>

      <div class="col-12 px-4 pb-0">
        <v-textarea
          :rules="[$utils.validators.required, $utils.validators.notEnglish]"
          v-model="loadSendersAndRecievers.address"
          label="آدرس دقیق"
          color="var(--logistic)"
          height="50"
          dir="rtl"
          outlined
          required
          dense
        ></v-textarea>
      </div>

      <div
        v-if="
          loadSendersAndRecievers.order_id !== 10 &&
          loadSendersAndRecievers.order_id !== 20
        "
        class="col-12 px-4 pb-0"
      >
        <v-btn
          @click="removePlaceForm(loadSendersAndRecievers.order_id)"
          class="error--text"
          text
        >
          <v-icon left>mdi-trash-can</v-icon>
          حذف محل بارگیری
          {{ placeIndex + 1 }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Drafts from "./Drafts.vue";

export default {
  components: { Drafts },
  props: {
    type: {
      type: String,
      require: true,
    },
    loadSendersAndRecievers: {
      type: Object,
    },
    placeIndex: Number,
    selectedCity: String,
    validate: Object,
  },
  data() {
    return {
      options: [
        {
          name: "شخصیت حقیقی",
          id: 2,
          active: true,
        },
        {
          name: "شخصیت حقوقی",
          id: 1,
          active: false,
        },
      ],
    };
  },
  methods: {
    switchOption(op) {
      this.options.map((option) => (option.active = false));

      this.loadSendersAndRecievers.type = op.id;
      op.active = true;
    },
    removePlaceForm(index) {
      this.$emit("delete", index);
    },
    handleCityDialog(op, data) {
      if (!data) return;
      this.loadSendersAndRecievers.ostan = data.state;
      this.loadSendersAndRecievers.city = data.city;
    },
  },
  computed: {
    place() {
      const type = this.type;
      return type == "receiver" ? "تخلیه" : "بارگیری";
    },
    nationalCode() {
      const type = this.options.find((option) => option.active == true);
      const mCode = {
        text: "کدملی ",
        length: 10,
      };
      const sCode = {
        text: "شناسه ملی ",
        length: 11,
      };
      return type.id == 2 ? mCode : sCode;
    },
    name() {
      const type = this.options.find((option) => option.active == true);
      return type.id == 2 ? "نام و نام خانوادگی " : "نام شخص / شرکت ";
    },
    inputs() {
      const inputs = [
        {
          label: this.name,
          model: "name",
          type: "text",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyFarsi,
          ],
        },
        {
          label: this.nationalCode.text,
          model: "code",
          type: "number",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(
              this.loadSendersAndRecievers["code"],
              this.nationalCode.length
            ),
          ],
        },
        {
          label: "شماره موبایل",
          model: "phone",
          type: "tel",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.iranmobile,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(
              this.loadSendersAndRecievers["phone"],
              11
            ),
          ],
        },
        {
          label: "تلفن ثابت ( کد استان الزامی )",
          model: "land_line",
          type: "tel",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(
              this.loadSendersAndRecievers["land_line"],
              11
            ),
          ],
        },
        {
          label: "کدپستی",
          model: "postal_code",
          type: "number",
          rule: [
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(
              this.loadSendersAndRecievers["postal_code"],
              10
            ),
          ],
        },
      ];
      return inputs;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 960px) {
  .px-md-30 {
    padding: 0 25vw;
  }
}
.border-grey {
  border: 1px solid #b8b8b8;
  border-radius: 4px !important;
}
.rounded-sides .id-option {
  &:first-child .border {
    border-radius: 0 4px 4px 0 !important;
  }
  &:last-child .border {
    border-radius: 4px 0 0 4px !important;
  }
}
</style>